// extracted by mini-css-extract-plugin
export default {"wrap":"PeriodButtons_wrap__5St97","selected":"PeriodButtons_selected__TkRHn"};